<template>
         <div class="row">
                <div class="col-sm-4 equipment-maintenance-counter">
                    <div class="equipment-maintenance-header">
                        <div class="equipment-maintenance-header-left d-flex align-items-center justify-content-between w-100">
                                <h2 class="ix-page-title-secondary"><i class="fas fa-tachometer-alt"></i> Compteurs</h2>
                                <button type="button" @click="openModalAddCounter()" class="ix-btn blue">
                                <i class="fas fa-plus"></i>
                                <span>Ajouter</span>
                                </button>
                        </div>
                        <div class="equipment-maintenance-header-right">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-center" v-if="listCounter">
                                <i class="far fa-circle-notch fa-spin"></i> 
                            </div>
                            <div class="alert alert-warning" v-if="counters && counters.length == 0 && !listCounter">Aucun compteur associé pour cet équipement</div>
                            <div class="ix-counters" v-if="counters && counters.length > 0 && !listCounter">
                                <div class="ix-counters-item" v-for="(count,index) in counters" :key="index" :class="{ 'active-counter' : counter && counters[index].id == counter.id}">
                                    <div class="ix-counters-item-left" @click="edit(index)">
                                        <span><i class="far fa-tachometer-slow"></i>
                                            <span v-html="truncate(count.name, 30)"></span>
                                            <span>-</span>
                                            <span v-html="count.actual_value"></span>
                                            <span v-html="count.unit ? count.unit : ''"></span>
                                        </span>
                                    </div> 
                                     <div class="ix-counters-item-right">
                                         <span @click="editCounterModal(index)"><i class="far fa-pen"></i></span>
                                         <span class="ml-2" @click="openModalReset(count)"><i class="far fa-repeat"></i></span>
                                         <span class="ml-2" @click="remove(count,index)"><i class="far fa-trash"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                
                </div>
                <div class="col-sm-8 equipment-maintenance-counter" v-show="counter && counter != null">
                    <h2 class="ix-page-title-secondary">Nouveau relevés</h2>
                    <div v-show="counter != null">
                        <div class="row">
                            <div class="col-sm-6">
                                <label for="realized_at" class="required">Date</label>  
                                 <v-date-picker v-model="form.measure.realized_at" mode="datetime" :timezone="timezone" is24hr :popover="{ visibility: 'click' }">
                                    <template v-slot="{ inputValue, inputEvents }">
                                    <input
                                        class="form-control"
                                        :value="inputValue"
                                        v-on="inputEvents"
                                        required="true"
                                        name="realized_at"
                                        id="realized_at"
                                    />
                                    </template>
                                </v-date-picker>
                            </div>
                            <div class="col-sm-6">
                                <label for="physical_value" class="required">Valeur lue</label>
                                <input type="number" class="form-control" name="physical_value" id="physical_value" v-model="form.measure.physical_value">
                            </div>
                        </div>
                        <div class="row">

                         
                        </div>
                        <div class="row">
                            <div class="col-sm-9 mt-2" v-show="errorMeasure">
                                <div class="alert alert-danger">{{ errorMeasure }}</div>
                            </div>
                            <div class="mt-2 text-right" :class="{'col-sm-3' : errorMeasure != null, 'col-sm-12' : !errorMeasure}">
                                <button type="button" class="ix-btn blue" @click="saveMeasure" :disabled="(!form.measure.realized_at || !form.measure.physical_value) || loadMeasure">
                                        <span>
                                            <i class="far fa-plus" v-if="!loadMeasure"></i>
                                            <i class="far fa-circle-notch fa-spin" v-if="loadMeasure"></i> 
                                            Enregistrer
                                        </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="counter != null">
                        <h2 class="ix-page-title-secondary">Relevés</h2>
                        <div class="alert alert-warning" v-if="measures && measures.length == 0">Aucun relevé associé au compteur <b>{{ counter.name }}</b></div>
                        <div class="row">
                            <div class="col-sm-12">
                                 <div class="text-center" v-if="listMeasure">
                                    <i class="far fa-circle-notch fa-spin"></i> 
                                </div>
                                <div class="ix-table-box" v-if="measures && measures.length > 0 &&  !listMeasure">
                                    <table class="ix-table ix-table-sm">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Par</th>
                                                <th>Valeur lue</th>
                                                <th>Valeur réelle</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(measure,index) in measures" :key="index">
                                                <td>
                                                    {{ measure.realized_at | formatDate('DD MMM YYYY') }}
                                                     <span v-if="measure.reset"><i class="fas fa-repeat"></i></span>
                                                </td>
                                                 <td>
                                                    <div class="ix-avatars-list">
                                                        <span class="ix-avatars-list-item">
                                                            <span class="ix-avatar sm" v-b-tooltip :title="measure.user.fullname">
                                                                <img :src="measure.user.avatar_path" v-if="measure.user.avatar_path">
                                                                <span v-if="!measure.user.logo_path"><i class="far fa-user"></i></span>
                                                            </span>
                                                        </span>
                                                        {{ measure.user.fullname }}
                                                    </div>
                                                </td>
                                                <td>
                                                    {{ measure.physical_value }}
                                                </td>
                                                <td>
                                                    {{ measure.actual_value }}
                                                </td>
                                                <td class="text-center">
                                                    <button type="button" class="btn ix-btn" @click="deleteMeasure(index)"><i class="far fa-trash"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="addCounterModal" tabindex="-1" aria-labelledby="addCounterModal" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Ajouter un compteur</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <i class="fal fa-times"></i>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-sm-12 mb-2">
                                        <label for="name" class="required">Nom</label>
                                        <input type="text" class="form-control" v-model="form.counter.name" name="name" id="name" required>
                                    </div>
                                    <div class="col-sm-12">
                                        <label for="name">Unité</label>
                                        <input type="text" class="form-control" v-model="form.counter.unit" name="unit" id="unit">
                                    </div>
                                    <div class="col-sm-12 text-right mt-2">
                                        <button type="button" class="ix-btn blue" @click="save" :disabled="!form.counter.name || loadCounter">
                                            <i class="far fa-plus"  v-if="!loadCounter && !editCounter"></i>
                                            <i class="fas fa-check"  v-if="!loadCounter && editCounter"></i>
                                            <i class="far fa-circle-notch fa-spin" v-if="loadCounter"></i>
                                            <span v-if="editCounter">Modifier</span>
                                            <span v-if="!editCounter">Ajouter</span>
                                        </button>
                                        <button type="button" class="ix-btn red" @click="reset()"><i class="fas fa-times"></i>Annuler</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="modal fade" id="resetCounterModal" tabindex="-1" aria-labelledby="resetCounterModal" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Remplacement du compteur</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <i class="fal fa-times"></i>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label for="realized_at" class="required">Date du remplacement</label>
                                         <v-date-picker v-model="form.reset.realized_at" mode="datetime" :timezone="timezone" is24hr :popover="{ visibility: 'click' }">
                                            <template v-slot="{ inputValue, inputEvents }">
                                            <input
                                                class="form-control"
                                                :value="inputValue"
                                                v-on="inputEvents"
                                                required="true"
                                                name="realized_at"
                                                id="realized_at"
                                            />
                                            </template>
                                        </v-date-picker>
                                        <div class="alert alert-warning mt-2">Attention, les relevés réalisés après cette date seront supprimés</div>
                                    </div>

                                    <div class="col-sm-12 mb-2">
                                        <label for="last_value" class="required">Dernière valeur lue avant remplacement</label>
                                        <input type="number" class="form-control" name="last_value" id="last_value" v-model="form.reset.last_value">
                                    </div>

                                     <div class="col-sm-12">
                                        <label for="initial_value" class="required">Valeur initiale du nouveau compteur</label>
                                        <input type="number" class="form-control" name="initial_value" id="initial_value" v-model="form.reset.initial_value">
                                    </div>

                                    <div class="col-sm-12 mt-2" v-if="errorReset && errorReset != null">
                                        <div class="alert alert-danger">{{ errorReset }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                 <button type="submit" class="ix-btn green" v-bind:disabled="(!form.reset.realized_at || !form.reset.last_value || !form.reset.initial_value) || loadingReset" @click="resetCounter()">
                                    <span v-if="!loadingReset">Enregistrer</span>
                                    <span v-if="loadingReset"><i class="far fa-circle-notch fa-spin"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                      
        </div>
</template>

<script>
import Swal from "sweetalert2";
import * as moment from 'moment'

export default {
    name: 'Counter',
    props: {
        url: String,
        equipmentId: String,
        measureUrl: String,
        resetUrl: String,
        errors: {},
    },
    data(){
        return {
            listCounter: false,
            loadCounter: false,
            loadMeasure: false,
            listMeasure: false,
            editCounter:false,
            loadingReset: false,
            form : {
                counter : {
                    name: null,
                    unit: null,
                },
                measure : {
                    realized_at: null,
                    physical_value: null,
                },  
                reset : {
                    realized_at: null,
                    last_value: null,
                    initial_value: null,
                }
            },
            counters: [],
            measures: [],
            counter: null,
            errorMeasure: null,
            errorReset: null,
            timezone : '',
        }
    },
    computed : {
        progress: function(){
            var progress = 0;
            if(this.counter && this.counter != null){
                progress = (this.counter.actual_value / 100000) * 100;
            }

            return progress;
        }
    },
    methods: {
        async getData(){
            this.listCounter = true;
            fetch(this.url + '?equipment_id='+ this.equipmentId, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders(),
            }).then((response) => {
                if (response.status == 200) {
                    response.json().then((data) => {
                        if (data) {
                            this.counters = data;
                            this.counter = this.counters.length > 0 ? this.counters[0] : null;
                            this.getMeasures();
                            
                        }
                    })
                }
                this.listCounter = false;
            }).catch((error) => {
                this.listCounter = false;
            })
        },
        save(){
            this.loadCounter = true;
            fetch(this.url  + (this.editCounter && this.counter && this.counter.id ? '/' + this.counter.id : ''), {
                 ...{
                        method: this.editCounter ? 'PUT' : 'POST'
                    },
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    body: JSON.stringify({
                        'name'          : this.form.counter.name,
                        'unit'          : this.form.counter.unit,
                        'equipment_id'  : this.equipmentId ? this.equipmentId : null
                    })
                }
            }).then((response) => {
                 if (response.status == 200) {
                    response.json().then((data) => {
                        if (data) {
                           this.form.counter.name = null;
                           this.form.counter.unit = null;
                            if(this.editCounter && this.counter != null){
                                this.counters[this.counter.index] = data;
                                this.counter = data;
                                this.editCounter = false;
                            }
                            else {
                                this.counters.push(data);
                            }
                        }
                    })
                }
                this.loadCounter = false;
                $('#addCounterModal').modal('hide');
            }).catch((error) => {
                this.loadCounter = false;
                 console.log(error);
                 $('#addCounterModal').modal('hide');
            });
        },
        edit(index){
            this.counter = this.counters[index];
            this.counter.index = index;
            this.editCounter = true;
            this.form.counter.name = this.counters[index].name;
            this.form.counter.unit = this.counters[index].unit;
            this.resetFormReset();
            this.getMeasures();
        },
        editCounterModal(index){
            this.counter = this.counters[index];
            this.counter.index = index;
            this.editCounter = true;
            this.form.counter.name = this.counters[index].name;
            this.form.counter.unit = this.counters[index].unit;
            this.resetFormReset();
            this.getMeasures();
            $('#addCounterModal').modal();
        },
        reset(){
            this.editCounter = false;
            this.form.counter.name = null;
            this.form.counter.unit = null;
            $('#addCounterModal').modal('hide');
        },
        remove(counter, index){
            this.$swal({
                    title : "Êtes vous sûr ?",
                    text : "Le compteur sera définitivement supprimé",
                    icon : "warning",
                    dangerMode : true,
                    buttons : ["Annuler" , "Supprimer"]
                }).then((willDo) => {
                    if(willDo){
                        this.listCounter = true

                        fetch(this.url + "/" + counter.id , {
                            ...{
                                method: 'DELETE'
                            },
                            ...this.getHttpJsonRequestHeaders()
                        }).then(async (response) => {
                            if (response.status == 200) {
                                this.counters.splice(index, 1);
                                this.counter = this.counters.length > 0 ? this.counters[0] : null;
                                this.form.counter.name = null;
                                this.form.counter.unit = null;
                                if(this.counters.length > 0)
                                    this.getMeasures();
                            } 
                            this.listCounter = false;
                            this.editCounter = false;
                        }).catch(error => {
                            this.listCounter = false
                        })
                    }
            });
        },
        async getMeasures(){
            this.listMeasure = true;
            if(this.counter){
                 fetch(this.measureUrl + '?counter_id='+ this.counter.id, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    if (response.status == 200) {
                        response.json().then((data) => {
                            if (data) {
                                this.measures = data;
                            }
                        })
                        
                        this.listMeasure = false;
                    }
                }).catch((error) => {
                    this.listMeasure = false;
                });
            }
           
        },
        saveMeasure(){
            if(this.counter != null){
                this.loadMeasure = true;
                this.errorMeasure = null;
                fetch(this.measureUrl, {
                        ...{
                            method: 'POST'
                        },
                        ...this.getHttpJsonRequestHeaders(),
                        ...{
                            body: JSON.stringify({
                                'realized_at': moment(this.form.measure.realized_at).format('L LT'),
                                'physical_value': this.form.measure.physical_value,
                                'counter_id': this.counter.id
                            })
                        }
                }).then((response) => {
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.counter = data['counter'];
                            this.form.measure.realized_at = null,
                            this.form.measure.physical_value = null,
                            this.counters[this.counters.findIndex(c => c.id == this.counter.id)] = this.counter;
                            this.getMeasures();
                        });
                    } else {
                        response.json().then((data) => {
                            this.errorMeasure = data.message;
                        });
                    }
                    this.errorMeasure = null;
                    this.loadMeasure = false;
                }).catch((error) => {
                      this.loadMeasure = false;
                });
            }
        },
        deleteMeasure(index){
             this.$swal({
                    title : "Êtes vous sûr ?",
                    text : "La mesure sera définitivement supprimée",
                    icon : "warning",
                    dangerMode : true,
                    buttons : ["Annuler" , "Supprimer"]
                }).then((willDo) => {
                    if(willDo){
                        this.listMeasure = true

                        fetch(this.measureUrl + "/" + this.measures[index].id , {
                            ...{
                                method: 'DELETE'
                            },
                            ...this.getHttpJsonRequestHeaders()
                        }).then(async (response) => {
                            if (response.status == 200) {
                                response.json().then((data) => {
                                    this.measures.splice(index, 1);
                                    this.counter = data['counter'];
                                    this.counters[this.counters.findIndex(c => c.id == this.counter.id)] = this.counter;
                                })
                            } 
                            this.listMeasure = false
                        }).catch(error => {
                            this.listMeasure = false
                            console.log(error);
                        })
                    }
            });
        },
        openModalReset(counter){
            this.counter = counter;
            $('#resetCounterModal').modal();
        },
        openModalAddCounter(){
            $('#addCounterModal').modal();
        },
        resetCounter(){
            this.loadingReset = true;
            this.errorReset = null;
            this.editCounter = false;
            fetch(this.resetUrl  + '?counter_id=' + this.counter.id, {
                 ...{
                        method: 'POST'
                    },
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    body: JSON.stringify({
                        'realized_at'    :  moment(this.form.reset.realized_at).format('L LT'),//this.form.reset.realized_at,
                        'last_value'     :  this.form.reset.last_value,
                        'initial_value'  :  this.form.reset.initial_value,
                    })
                }
            }).then((response) => {
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.resetFormReset();
                        this.getData();
                        $('#resetCounterModal').modal('hide');
                    });
                } else {
                    response.json().then((data) => {
                        this.errorReset = data.message;
                    });
                }
                this.errorReset = null;
                this.loadingReset = false;
            }).catch((error) => {
                this.loadingReset = false;
                console.log(error)
            });
        },
        resetFormReset(){
            this.form.reset.realized_at = null;
            this.form.reset.last_value = null;
            this.form.reset.initial_value = null;
        },
    },
    async mounted(){
        await this.getData();
    }
}
</script>

<style lang="scss">
    .ix-counters-item{
        display: flex;
        justify-content: space-between;
        padding: 10px;
    }
    .ix-counters-item-left {
        font-weight: bold;
        width: 66.33%;
        max-width: 66.33%;
    }

    .ix-counters-item:hover{
        background: #f6f8fa;
        border-radius: 5px;
        cursor: pointer;
    }

    .active-counter {
        background: #0366d6 !important;
        color: white !important;
        border-radius: 5px;
    }

    .equipment-counter-detail {
        width: 100%;
        height: 30px;
        background-color: #eaeaea;
        border-radius: 10px;
        overflow: hidden;
        margin: 10px;
    }

    .ix-counter-actual {
        height: 100%;
        background-color: #2ABCA4;
        width: 0;
        transition: width 0.3s ease-in-out;
        border-radius: 10px 0px 0px;
        font-size: 18px;
        font-weight: bold;
        max-width: 100%;
    }
   /* .ix-counter-actual {
        font-size: 27px;
        margin: 0;
        padding: 0;
        color: #5B6D8C;
        display: block;
    }*/
</style>